const convertObjValueToString = (obj: Record<string, any>): Record<string, string> =>
  Object.entries(obj).reduce((acc, [key, value]) => ({
    ...acc,
    [key]: String(value),
  }), {});

export function isEqualPlaneObjs (obj1: Record<string, any>, obj2: Record<string, any>): boolean {
  return JSON.stringify(convertObjValueToString(obj1)) === JSON.stringify(convertObjValueToString(obj2));
}